import { createRouter, createWebHistory } from 'vue-router'
import { ReviseMeta } from '@/util/meta'
import { deviceType } from '@/util/base'

function createAdRoutes(platforms) {
  return platforms.flatMap(({ prefix, versions }) =>
    versions.map((version) => {
      const path = `${prefix}-${version}`
      return {
        path,
        name: path,
        component: () => import('./views/down/index.vue')
      }
    })
  )
}

const adRoutesVersions = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'B2',
  'C2',
  'D2'
]

// RequestID 映射配置 - 模板与ID对应关系（不区分渠道）
const requestIDMap = {
  A: '14',
  B: '15',
  C: '16',
  D: '17',
  E: '18',
  F: '19',
  G: '20',
  H: '21',
  I: '22',
  J: '23',
  K: '24',
  L: '25',
  M: '26',
  N: '27',
  O: '28',
  P: '29',
  Q: '30',
  R: '31',
  S: '32',
  T: '33',
  U: '34',
  V: '35',
  W: '36',
  X: '37',
  Y: '38',
  Z: '39'
}

// 获取RequestID的函数
const getRequestID = (path) => {
  const pathParts = path.split('/')
  const lastPart = pathParts[pathParts.length - 1]

  // 处理带 /m 的路径
  let cleanPart = lastPart
  if (cleanPart && cleanPart.startsWith('/')) {
    cleanPart = cleanPart.substring(1)
  }

  // 提取模板部分（例如：FB-A -> A, GG-B -> B, 或者直接是 A, B）
  if (cleanPart) {
    // 如果包含连字符，取最后部分作为模板
    const template = cleanPart.includes('-') ? cleanPart.split('-')[1].toUpperCase() : cleanPart.toUpperCase()
    return requestIDMap[template] || '14' // 默认14
  }

  return '14' // 默认返回14
}

const adRoutes = createAdRoutes([
  {
    prefix: 'TT', // 抖音
    versions: adRoutesVersions
  },
  {
    prefix: 'FB', // 脸书
    versions: adRoutesVersions
  },
  {
    prefix: 'GG', // 谷歌
    versions: adRoutesVersions
  },
  {
    prefix: 'tw', // 推特
    versions: adRoutesVersions
  },
  {
    prefix: 'TW', // 推特
    versions: adRoutesVersions
  },
  {
    prefix: 'Zucksad', // Zucksad渠道
    versions: adRoutesVersions
  },
  {
    prefix: 'Zucks', // Zucks渠道
    versions: adRoutesVersions
  },
  {
    prefix: 'AMoAd', // AMoAd渠道
    versions: adRoutesVersions
  },
  {
    prefix: 'SeedApp', // SeedApp渠道
    versions: adRoutesVersions
  },
  {
    prefix: 'imobile', // imobile渠道
    versions: adRoutesVersions
  },
  {
    prefix: 'SKYFLAG', // SKYFLAG渠道
    versions: adRoutesVersions
  },
  {
    prefix: 'Smartnews', // Smartnews渠道
    versions: adRoutesVersions
  },
  {
    prefix: 'line', // line渠道
    versions: adRoutesVersions
  },
  {
    prefix: 'unicorn', // unicorn渠道
    versions: adRoutesVersions
  }
])

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面 预约期 官网先展示预约
    {
      path: '/',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    {
      path: '/m',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    // 官网新闻
    {
      path: '/news',
      component: () => import('./views/gw/news.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    {
      path: '/news/m',
      component: () => import('./views/gw/news.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    // 官网内容
    {
      path: '/content',
      component: () => import('./views/gw/content.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    {
      path: '/content/m',
      component: () => import('./views/gw/content.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    // 预约页
    {
      path: '/pre',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    {
      path: '/pre/m',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    // 预约页FB
    {
      path: '/pre/FB',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    {
      path: '/pre/FB/m',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    // 预约页GG
    {
      path: '/pre/GG',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    {
      path: '/pre/GG/m',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    // 预约页TT
    {
      path: '/pre/TT',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    {
      path: '/pre/TT/m',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Vật Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      }
    },
    // 下载
    {
      path: '/down',
      meta: {
        title: 'Ragnarok Twilight - Chạng Vạng Đăng Ký Trước nhận Thú Cưỡi & Cánh Độc Quyền!',
        keywords:
          'RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight - Chạng Vạng，RO Idle Adventure Plus,Ragnarok M:Eternal Love, Ragnarok:Origin, Ragnarok:BackToGlory, The Ragnarok,MMORPG, RPG, Loot, Bonus，GRAVITY，Baphomet, Game Kinh Điển，Trang web chính thức Ragnarok Online，RO online, MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Phó Bản, Raid, Guild War，pvp，gvg，Zeny, Top Game Miễn Phí，Tỉ Lệ Rơi 100%，Hero，Biến Thân Anh Hùng，Poring，Baphomet',
        description:
          'Tựa game mobile RPG phiêu lưu RO rơi Trang Bị với Anh Hùng đầu tiên, Ragnarok Twilight - Chạng Vạng đã mở đăng ký trước! Đăng ký trước ngay để nhận Thú Cưỡi phiên bản giới hạn, Trang Phục và Cánh hiếm, cùng cơ hội trúng iPhone 17 Pro, Xu Vàng và Quà Lưu Niệm! Đánh bại MVP với「Tỉ Lệ Rơi 100%」, nằm không treo máy thắng dễ dàng! 「Biến Thân Anh Hùng」lần đầu ra mắt cho phép người chơi hóa thân thành những anh hùng MVP/BOSS kinh điển như Baphomet!'
      },
      children: adRoutes
    },
    // 注意事项协议
    {
      path: '/protocol',
      component: () => import('./views/protocol.vue')
    },
    {
      path: '/protocol/m',
      component: () => import('./views/protocol.vue')
    },
    // 404
    {
      path: '/:pathMatch(.*)*',
      component: () => import('../../components/404.vue')
    }
  ]
})
router.beforeEach((to, from, next) => {
  // 路由发生变化改变 description 和 keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description)

  // 定义特殊页面白名单，使用正则表达式匹配通配符
  const specialPages = [/^\/down(\/.*)?$/]

  // 检查当前路径是否在特殊页面白名单中
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path))

  // 如果是特殊页面，直接调用 next()
  if (isSpecialPage) {
    next()
    return
  }

  const isWap = deviceType() == 'wap'

  // 定义PC端和移动端路径
  let pcPath = to.path.replace(/\/m$/, '')
  let wapPath = pcPath.endsWith('/') ? `${pcPath}m` : `${pcPath}/m`

  // 根据设备类型跳转，避免重复添加或删除斜杠
  if (isWap && !to.path.endsWith('/m')) {
    next({ path: wapPath, query: to.query })
  } else if (!isWap && to.path.endsWith('/m')) {
    next({ path: pcPath, query: to.query })
  } else {
    next()
  }
})

export default router
export { getRequestID }
